{
  "ts": 1750324318,
  "tsCommit": 1750324170,
  "repoName": "WebSignup",
  "branchName": "prod",
  "rev": "fb9ca5d",
  "ver": "20250619_0911_WebSignup_prod_fb9ca5d",
  "env": "production",
  "isBranchDeployment": false
}
